import React from "react";
import WidgetLoading from "./WidgetLoading";
import utils from "../../app/UtilityService";
import containerUtils, { resolveChildren } from "../../utils/containerUtils";
import { Preloader } from "@tinqin/tinqin-ui-components/src/preloader";

const LoadingAnimationContainer = (props) => {

        let uiState = props.uiState || {};
        let loading = uiState.loading;
        let isLoading = loading > 0;
        let children = resolveChildren(props);
        let extractedProps = containerUtils.extractComponentProps(props, {
            componentProps: Preloader.propTypes,
            additionalProps: [
                "minLoadingTime",
                "contentRenderWaitingTime",
                "fadeinTime",
                "fadeoutTime"
            ]
        });
        return (
            <WidgetLoading isLoading={isLoading} {...extractedProps}>
                {children}
            </WidgetLoading>
        );
}

export default utils.connectComponent({ uiState: true })(LoadingAnimationContainer);
